export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const API_KEY = '994d5116-1472-4c53-8d9d-abfd31834afd';
export const MODAL_CLOSE_SEC = 2.5;